<template>
	<div class="page_container flex_wrap column j_c_between a_i_center">
		<header class="title">
			<h1>拼车销售查询统计</h1>
			<div class="filtrate_wrap flex_wrap wrap">
				<div class="select_wrap flex_wrap j_c_center a_i_center">
					<select class="select">
						<option :value="item.value" v-for="(item, index) in dateSelection" :key="index">{{ item.text }}</option>
					</select>
				</div>
				<!-- 				<div class="select_wrap flex_wrap j_c_center a_i_center">
					<select class="select" name="sel_ModelType" id="Sel_ModelType">
					</select>
				</div> -->
				<!-- 				<div class="select_wrap flex_wrap j_c_center a_i_center">
					<select class="select" name="Sel_StatInterval" id="Sel_StatInterval">
						<option value="day">日统计</option>
						<option value="month">月统计</option>
						<option value="year">年统计</option>
					</select>
				</div> -->
				<div class="date_wrap flex_wrap a_i_center j_c_around">
					<input class="date" type="date" v-model="startDate" />
					<span class="">至</span>
					<input class="date" type="date" v-model="endDate" />
				</div>
				<div class="select_wrap flex_wrap j_c_center a_i_center"><input class="date" type="text" v-model="fromParams" /></div>
				<!-- 				<div class="select_wrap flex_wrap j_c_center a_i_center">
					<select class="select" name="Sel_OrderState" id="Sel_OrderState">
						<option value="all">全部订单</option>
						<option value="checked">有效订单</option>
					</select>
				</div> -->

				<div class="btn_wrap flex_wrap"><button class="btn demand_btn" @click="getReportData">统计</button></div>
			</div>
		</header>
		<div class="index_content">
			<h3>统计结果</h3>
			<div class="table statistics_table">
				<ul class="tr bg_tr flex_wrap">
					<li class="th">销售</li>
					<li class="th">拉新单数</li>
					<li class="th">回头单数</li>
					<li class="th">拉新提成</li>
					<li class="th">回头提成</li>
					<li class="th">合计提成</li>
				</ul>
				<ul class="tr flex_wrap" v-for="(record, index) in reportData" :key="index">
					<li class="td">{{ record.FromParams }}</li>
					<li class="td">{{ record.NewOrder }}</li>
					<li class="td">{{ record.ReBuyOrder }}</li>
					<li class="td">{{ record.NewBonus }}</li>
					<li class="td">{{ record.ReBuyBonus }}</li>
					<li class="td">{{ record.TotalBonus }}</li>
				</ul>
			</div>
		</div>
		<footer class=""></footer>
	</div>
</template>

<script>
import baseTool from '@/utils/baseFunction';
import salesApi from '@/request/salesApi';
export default {
	name: 'SalesStatReport',
	data() {
		return {
			startDate: '',
			endDate: '',
			dateType: 'create',
			dateSelection: [{ text: '下单日期', value: 'create' }, { text: '预约日期', value: 'appoint' }],
			reportData: [],
			fromParams: ''
		};
	},
	activated() {
		this.startDate = baseTool.dateFormat(new Date(), 'yyyy-MM-dd');
		this.endDate = baseTool.dateFormat(new Date(), 'yyyy-MM-dd');
	},
	methods: {
		getReportData() {
			this.reportData = [];
			salesApi.getSalesReport(this.startDate, this.endDate, this.dateType, this.fromParams).then(sucRes => {
				if (sucRes.success && sucRes.data && sucRes.data.length > 0) {
					this.reportData = sucRes.data;
				}
			});
		}
	}
};
</script>

<style scoped="scoped" type="text/css">
.title {
	width: 100%;
	background-color: #005242;
	text-align: center;
}
.title h1 {
	width: 100%;
	line-height: 10vh;
	color: #fff;
	font-size: 0.5rem;
}
.filtrate_wrap {
	width: 100%;
	border-top: 5px solid #f8f8f8;
	padding: 0.2rem 0;
}
.filtrate_wrap > div {
	margin: 0.2rem 0 0.2rem 0.3rem;
}
.select_wrap,
.date_wrap,
.btn_wrap {
	align-self: stretch;
	height: 4vh;
	position: relative;
}
.select,
.date {
	box-sizing: border-box;
	align-self: stretch;
	background-color: #555;
	font-size: 0.35rem;
	outline: none;
	color: #fff;
	border: 1px solid #888;
}

.select {
	width: 100%;
}

.date_wrap > span {
	margin: 0 0.2rem;
	color: #fff;
}
.demand_btn {
	background-color: #f8f8f8;
	color: #333;
}
.demand_btn:active {
	background-color: #ddd;
	color: #555;
}

.index_content {
	width: 100%;
	flex: 1;
	padding: 0.2rem;
	overflow-y: scroll;
}
.table {
}
.bg_tr {
	background-color: #888;
}
.tr {
	color: #fff;
}
.td {
	color: #888;
}
.statistics_table .tr:last-child .td {
	color: #fff;
}
.bg_huizong {
	background-color: #2fdab9;
}

.tong_ji {
	border-bottom: 1px solid #888;
}
.index_content h3:nth-child(n + 2) {
	margin-top: 0.2rem;
}
.index_content h3 {
	text-align: center;
	color: #fff;
	line-height: 4vh;
	background-color: #06967a;
}

body,
ol,
ul,
h1,
h2,
h3,
h4,
h5,
h6,
p,
th,
td,
dl,
dd,
form,
fieldset,
legend,
input,
textarea,
select {
	margin: 0;
	padding: 0;
}
body {
	font: 12px/24px '微软雅黑', 'Arial Narrow', HELVETICA;
	-webkit-text-size-adjust: 100%;
}
a {
	color: #2d374b;
	text-decoration: none;
}
a:hover {
	color: #cd0200;
	text-decoration: underline;
}
em {
	font-style: normal;
}
li {
	list-style: none;
}
button,
input {
	outline: none;
}
img {
	border: 0;
	vertical-align: middle;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
div {
	box-sizing: border-box;
}
p {
	word-wrap: break-word;
}

html {
	height: 100%;
}

body {
	margin: 0 auto;
	width: 10rem;
	height: 100%;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
}
.page_container {
	width: 100%;
	height: 100%;
	margin: 0 auto;
}
.flex_wrap {
	display: flex;
}
.row {
	flex-direction: row;
}
.column {
	flex-direction: column;
}
.wrap {
	flex-wrap: wrap;
}
.j_c_center {
	justify-content: center;
}
.j_c_start {
	justify-content: flex-start;
}
.j_c_end {
	justify-content: flex-end;
}
.j_c_around {
	justify-content: space-around;
}
.j_c_between {
	justify-content: space-between;
}
.a_i_center {
	align-items: center;
}
.a_i_start {
	align-items: flex-start;
}
.a_i_end {
	align-items: flex-end;
}

.btn {
	outline: none;
	border: 1px solid #888;
	border-radius: 4px;
}

.table {
	width: 100%;
	border: 1px solid #aaa;
}
.table:nth-child(n + 2) {
	margin-top: 0.2rem;
}
.tr {
	justify-content: space-around;
	align-items: center;
	flex: 1;
}
.th:nth-last-child(n + 2),
.td:nth-last-child(n + 2) {
	border-right: 1px solid #ddd;
}
.tr:nth-last-child(n + 2) {
	border-bottom: 1px solid #ddd;
}
.th,
.td {
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	align-self: stretch;
	flex-wrap: wrap;
	word-break: break-all;
	text-align: center;
}
.td {
	padding: 0.1rem;
}

@font-face {
	font-family: 'iconfont'; 
	src: url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.eot');
	src: url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.eot?#iefix') format('embedded-opentype'), url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.woff') format('woff'),
		url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.ttf') format('truetype'), url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.svg#iconfont') format('svg');
}
.iconfont {
	font-family: 'iconfont' !important;
	/*font-size:40rpx;*/
	margin: 0 5px;
	font-style: normal;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
.iconreversal {
	transition: all 0.3s;
	display: inline-block;
	transform: scaleY(-1);
}
.noticonreversal {
	transition: all 0.3s;
	display: inline-block;
	transform: scaleY(1);
}

</style>



// WEBPACK FOOTER //
// src/components/SalesStatReport.vue